// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedQuestions_container__qwxQ_"};